import { useEffect, useRef } from "react";
import en from "dictionaries/en.json";
import lt from "dictionaries/lt.json";
import { useLanguage } from "providers/language";
import * as CookieConsent from "vanilla-cookieconsent";
import { Language } from "types/locale";

const createConsentTranslation = (dict: typeof lt.cookieConstent): CookieConsent.Translation => ({
  consentModal: {
    title: dict.title,
    description: dict.description,
    acceptAllBtn: dict.acceptAll,
    acceptNecessaryBtn: dict.acceptNecessary,
    showPreferencesBtn: dict.showPreferences,
  },
  preferencesModal: {
    title: dict.title,
    acceptAllBtn: dict.acceptAll,
    acceptNecessaryBtn: dict.acceptNecessary,
    savePreferencesBtn: dict.savePreferences,
    closeIconLabel: dict.close,
    sections: [
      {
        title: dict.necessaryCookiesSection.title,
        description: dict.necessaryCookiesSection.description,
        linkedCategory: "necessary",
        cookieTable: {
          headers: {
            name: dict.cookiesTable.header.name,
            description: dict.cookiesTable.header.description,
            expiration: dict.cookiesTable.header.expiration,
          },
          body: dict.cookiesTable.body.map((item) => ({
            name: item.title,
            description: item.description,
            expiration: item.expiration,
          })),
        },
      },
    ],
  },
});

export const useCookieConsent = () => {
  const { lang } = useLanguage();
  const initialization = useRef<Promise<void> | null>(null);

  useEffect(() => {
    let active = true;
    // StrictMode and language changes must reuse the same initialization.
    initialization.current ??= CookieConsent.run({
      categories: {
        necessary: { enabled: true, readOnly: true },
      },
      language: {
        default: lang,
        translations: {
          [Language.Lt]: createConsentTranslation(lt.cookieConstent),
          [Language.En]: createConsentTranslation(en.cookieConstent),
        },
      },
    });

    void initialization.current.then(() => {
      if (active) {
        void CookieConsent.setLanguage(lang);
      }
    });

    return () => {
      active = false;
    };
  }, [lang]);
};
